import clsx from 'clsx';

type Props = {
  onClick: () => void;
  variant: 'modal' | 'dialog';
};

export default function CloseButton({onClick, variant}: Props) {
  return (
    <button
      onClick={onClick}
      className={clsx(
        'absolute flex h-12 w-12 items-center justify-center rounded-full bg-orange/30 ',
        variant === 'modal' && 'top-2 right-2 lg:top-10 lg:right-10',
        variant === 'dialog' && 'top-[14px] right-[14px]',
      )}
    >
      <svg
        width={'18'}
        height={'19'}
        viewBox={`0 0 18 19`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5137 1.37918C17.0051 0.87062 16.1807 0.870619 15.6722 1.37918L8.99609 8.05527L2.32 1.37918C1.81144 0.870619 0.987046 0.87062 0.478488 1.37918C-0.0300711 1.88774 -0.0300703 2.71213 0.478488 3.22069L7.15458 9.89678L0.478488 16.5729C-0.0300718 17.0814 -0.0300698 17.9058 0.478489 18.4144C0.987048 18.9229 1.81144 18.923 2.32 18.4144L8.9961 11.7383L15.6722 18.4144C16.1807 18.9229 17.0051 18.9229 17.5137 18.4144C18.0223 17.9058 18.0223 17.0814 17.5137 16.5729L10.8376 9.89678L17.5137 3.22069C18.0223 2.71214 18.0223 1.88774 17.5137 1.37918Z"
          fill="#F27021"
        />
      </svg>
    </button>
  );
}
